import axios from 'axios'
import router from '../router/index'
import {
    Message
} from 'element-ui';
const request = axios.create({
    // baseURL: 'http://www.fastmock.site/mock/93683a7e3af3a4da7c444edce39be668/api', ///fastmock路径
    // baseURL: 'http://45.40.228.47:8085',
    baseURL: process.env.NODE_ENV === "production" ? process.env.BASE_API : "/api",
    // baseURL: 'https://www.lsgcloud.com/' //线上挂域名


})

// 请求拦截器
// Add a request interceptor
request.interceptors.request.use(
    //所有请求会经过这里
    //config 是当前请求相关的配置对象
    //config 是可以修改的
    function(config) {
        const token = JSON.parse(window.sessionStorage.getItem('token'))
            //如果有登录用户信息，则同意设置token
        if (token) {
            config.headers.Authorization = token
        }
        // 当这里return config之后请求才会真正的发出去
        return config
    },
    // 请求失败，会经过这里
    function(error) {
        return Promise.reject(error)
    }
)


//响应拦截器
request.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        // if (error.response.status == 401) {
        //     router.push({
        //         path: "/",
        //         query: {
        //             name: error.response.data.message
        //         } //从哪个页面跳转
        //     })
        //     Message({
        //         message: error.response.data.message,
        //         type: "error",
        //         duration: 3000,
        //     });
        // }
        return Promise.reject(error)
    }
)

//导出请求方法
export default request
